module.exports = __webpack_public_path__ + "img/nota-folio-fysson.8591158e.png";